import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'
import MAX_INPUT_COUNT from './constants'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.includedEmojis === undefined ||
  widgetSetting.includedEmojis === null ||
  widgetSetting.includedEmojis.length === 0

const isOverMaxInput = (insights: InsightData[]) => insights.length > MAX_INPUT_COUNT

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => ({
  ...widgetSetting,
  includedEmojis: [
    ...(widgetSetting.includedEmojis || []),
    ...Array.from(insights).map((insight) => insight.name)
  ]
})

const generateIncludedEmojisStrategy = (): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput,
  composeDrillDownWidgetSetting
})

export default generateIncludedEmojisStrategy
